import oracles from './oracles';

export default {
  appName: 'Oracle',
  appNameShort: 'oracle',
  logoutMinutes: 15,
  nodeUrl: 'https://mainnet-nodes.zp.io',
  oracleUrl: {
    main: 'https://oracle-main.zp.io',
    test: 'https://oracle-test.zp.io',
  },
  oracles,
  chain: 'main',
  zenJsVersion: process.env.REACT_APP_ZENJS_VERSION || '0.0.0',
  buildVersion: process.env.REACT_APP_BUILD_VERSION || '0.0.0',
  contract: {
    main: process.env.REACT_APP_ORACLE_CONTRACT_ID_MAIN,
    test: process.env.REACT_APP_ORACLE_CONTRACT_ID_TEST,
  },
  explorer: {
    main: process.env.REACT_APP_EXPLORER_MAIN || 'https://zp.io',
    test: process.env.REACT_APP_EXPLORER_TEST || 'https://testnet.zp.io',
  },
  errorReporting: {
    endpoint: process.env.REACT_APP_CONFIG_REPORT_ERRORS_ENDPOINT,
    token: process.env.REACT_APP_CONFIG_REPORT_ERRORS_TOKEN,
    attributes: {
      processType: 'web',
      NODE_ENV: process.env.NODE_ENV,
      zenJsVersion: process.env.REACT_APP_ZENJS_VERSION || 'unknown',
      buildVersion: process.env.REACT_APP_BUILD_VERSION || 'unknown',
      // override for anonymity
      referer: '',
      hostname: '',
    },
  },
};
